{
  "app": {
    "name": "OneVerse",
    "loading": "Loading...",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "confirm": "Confirm",
    "submit": "Submit",
    "edit": "Edit",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "search": "Search",
    "filter": "Filter",
    "export": "Export",
    "yes": "Yes",
    "no": "No",
    "required": "Required",
    "optional": "Optional",
    "none": "None",
    "unknown": "Unknown",
    "error": "An error occurred. Please try again.",
    "powered_by": "Powered by {{name}}"
  },
  "nav": {
    "home": "Home",
    "dashboard": "Dashboard",
    "submissions": "Submissions",
    "studies": "Studies",
    "sites": "Sites",
    "users": "Users",
    "settings": "Settings",
    "notifications": "Notifications",
    "admin": "Admin",
    "help": "Help",
    "sign_out": "Sign Out",
    "logout": "Logout",
    "expand_sidebar": "Expand sidebar",
    "collapse_sidebar": "Collapse sidebar"
  },
  "auth": {
    "sign_in": "Sign In",
    "sign_in_button": "Sign in",
    "sign_out": "Sign Out",
    "email": "Email",
    "email_placeholder": "Enter your email",
    "password": "Password",
    "password_placeholder": "Enter your password",
    "forgot_password": "Forgot password?",
    "reset_password": "Reset your password",
    "enter_reset_code": "Enter reset code",
    "reset_code_instructions": "Enter your email address and we'll send you a code to reset your password.",
    "new_code_instructions": "Enter the code and your new password.",
    "send_reset_code": "Send reset code",
    "sending": "Sending...",
    "reset_password_action": "Reset password",
    "resetting": "Resetting...",
    "create_account": "Create Account",
    "welcome": "Welcome to OneVerse",
    "welcome_back": "Welcome back",
    "subtitle": "Please enter your details.",
    "no_account": "Don't have an account?",
    "sign_up": "Sign up",
    "remember_password": "Remember your password?",
    "confirmation_code": "Confirmation Code",
    "confirmation_code_placeholder": "Enter the code from your email or text message",
    "confirm_email": {
      "title": "Verify your email",
      "instructions": "We sent a confirmation code to {{email}}. Enter it below to verify your email address.",
      "instructions_standalone": "Enter your email and the confirmation code we sent you to finish verifying your account.",
      "code_placeholder": "Enter the code from your email",
      "code_required": "Confirmation code is required",
      "verify": "Verify email",
      "verifying": "Verifying...",
      "resend": "Resend code",
      "resend_in": "Resend code in {{seconds}}s",
      "confirm_later": "Enter your code later"
    },
    "registration_success": {
      "title": "Email verified — thank you for registering!",
      "pending_review": "A member of the Univo Team will review your account request and you will receive a follow up email shortly.",
      "approved_title": "Email verified — your account is ready!",
      "approved_body": "You can now sign in with your email and password.",
      "sign_in": "Sign in"
    },
    "new_password": "New Password",
    "new_password_placeholder": "Enter your new password",
    "confirm_password": "Confirm New Password",
    "confirm_password_placeholder": "Confirm your new password",
    "mfa": {
      "code": "Code",
      "back_to_login": "Back to Login",
      "sms_placeholder": "Enter the code sent to your phone",
      "email_placeholder": "Enter the code sent to your email",
      "totp_placeholder": "Enter the code from your authenticator app",
      "lost_device": "I lost access to my authenticator device",
      "reset_request_sending": "Sending request...",
      "reset_request_error": "We couldn't send your request. Please try again.",
      "reset_request_sent_title": "Request received",
      "reset_request_sent_body": "An administrator will review your request. You'll receive an email once a decision has been made — after approval you can sign in with just your password and set up a new authenticator.",
      "reset_request_already_pending": "You already have a pending reset request. An administrator will review it and you'll receive an email once a decision has been made."
    },
    "show_password": "Show password",
    "hide_password": "Hide password",
    "errors": {
      "invalid_credentials": "Invalid email or password.",
      "account_locked": "Your account has been locked. Please contact support.",
      "session_expired": "Your session has expired. Please sign in again.",
      "email_required": "Email is required",
      "email_password_required": "Email and password are required",
      "all_fields_required": "All fields are required",
      "passwords_dont_match": "Passwords do not match",
      "unexpected": "An unexpected error occurred",
      "server_non_json": "Server returned non-JSON response. Check console for details."
    }
  },
  "dashboard": {
    "welcome": "Welcome, {{name}}",
    "new_submission": "New Submission",
    "submission_overview": "Submission Overview",
    "view_all_submissions": "View All Submissions",
    "recent_activity": "Recent Activity",
    "no_recent_activities": "No recent activities.",
    "search_placeholder": "Search",
    "total": "Total",
    "submission_singular": "submission",
    "submission_plural": "submissions",
    "active_site_status": "Active Site Status",
    "view_study": "View Study",
    "loading_studies": "Loading studies...",
    "select_study": "Select a study",
    "view_details": "View details",
    "news_and_notes": "News & Notes",
    "no_recent_posts": "No recent posts.",
    "failed_to_load_announcements": "Failed to load announcements",
    "statuses": {
      "response_required": "Response Required",
      "drafts": "Drafts",
      "submitted": "Submitted",
      "pre_review": "Pre-review",
      "irb_review": "IRB Review",
      "post_review": "Post-review",
      "expiring_soon": "Expiring Soon"
    }
  },
  "submissions": {
    "title": "Submissions",
    "new": "New Submission",
    "empty": "No submissions found.",
    "empty_yet": "No submissions yet.",
    "search_placeholder": "Search by ID or title",
    "filter": {
      "all_statuses": "All statuses",
      "all_types": "All types",
      "status_label": "Status",
      "type_label": "Type"
    },
    "errors": {
      "failed_to_load": "Failed to load submissions"
    },
    "status": {
      "pending": "Pending",
      "under_review": "Under Review",
      "approved": "Approved",
      "rejected": "Rejected",
      "revisions_required": "Revisions Required",
      "withdrawn": "Withdrawn",
      "expired": "Expired",
      "closed": "Closed",
      "draft": "Draft",
      "submitted": "Submitted",
      "pre_review": "Pre-Review",
      "irb_review": "IRB Review",
      "post_review": "Post-Review",
      "response_required": "Response Required",
      "expiring_soon": "Expiring Soon",
      "complete": "Complete",
      "deleted": "Deleted"
    },
    "fields": {
      "id": "ID",
      "title": "Title",
      "protocol_number": "Protocol Number",
      "principal_investigator": "Principal Investigator",
      "submitted_at": "Submitted",
      "submitted": "Submitted",
      "updated_at": "Last Updated",
      "expiration": "Expiration",
      "status": "Status",
      "type": "Type"
    },
    "actions": {
      "view": "View Submission",
      "edit": "Edit Submission",
      "withdraw": "Withdraw",
      "submit": "Submit for Review"
    }
  },
  "studies": {
    "title": "Studies",
    "new": "New Study",
    "empty": "No studies found.",
    "empty_yet": "No studies yet.",
    "search_placeholder": "Search by ID or title",
    "filter": {
      "all_statuses": "All statuses",
      "all_types": "All types",
      "type_label": "Type",
      "attribute_label": "Attribute",
      "all_attributes": "All attributes",
      "attribute_value_placeholder": "Attribute value"
    },
    "errors": {
      "failed_to_load": "Failed to load studies"
    },
    "fields": {
      "id": "ID",
      "title": "Study Title",
      "type": "Type",
      "irb_number": "IRB Number",
      "pi": "Principal Investigator",
      "status": "Status",
      "submitted": "Submitted",
      "start_date": "Start Date",
      "end_date": "End Date",
      "expiration": "Expiration",
      "protocol_number": "Protocol Number",
      "pi_name": "PI Name",
      "sponsor_name": "Sponsor Name",
      "sites_count": "# Sites",
      "initial_completed_date": "Initial Completed Date"
    },
    "standalone": "standalone",
    "sort_by": "Sort by {{column}}",
    "attributes": {
      "cro": "CRO",
      "sponsor": "Sponsor",
      "pi": "PI",
      "pi_email": "PI Email",
      "poc": "POC",
      "poc_email": "POC Email",
      "poc_phone": "POC Phone",
      "poc_role": "POC Role"
    }
  },
  "sites": {
    "title": "Sites",
    "new": "New Site",
    "empty": "No sites found.",
    "empty_yet": "No sites yet.",
    "search_placeholder": "Search by ID, site name, or PI",
    "filter": {
      "all_statuses": "All statuses",
      "all_countries": "All countries",
      "country_label": "Country"
    },
    "errors": {
      "failed_to_load": "Failed to load sites"
    },
    "fields": {
      "id": "ID",
      "site_name": "Site Name",
      "country": "Country",
      "protocol_number": "Protocol Number",
      "sponsor_name": "Sponsor Name",
      "pi_name": "PI Name",
      "approved": "Approved",
      "expiration": "Expiration",
      "status": "Status"
    }
  },
  "entity": {
    "status": {
      "in_progress": "In Progress",
      "active": "Active",
      "rejected": "Rejected",
      "suspended": "Suspended",
      "closed": "Closed",
      "expired": "Expired"
    }
  },
  "activities": {
    "submission_approved": "Submission Approved",
    "submission_created": "Submission Created",
    "submission_submitted": "Submission Submitted",
    "submission_updated": "Submission Updated",
    "submission_withdrawn": "Submission Withdrawn",
    "submission_rejected": "Submission Rejected",
    "submission_expired": "Submission Expired",
    "study_created": "Study Created",
    "study_updated": "Study Updated",
    "site_created": "Site Created",
    "site_updated": "Site Updated",
    "status_changed": "Status Changed",
    "review_started": "Review Started",
    "review_completed": "Review Completed",
    "comment_added": "Comment Added",
    "document_uploaded": "Document Uploaded",
    "response_required": "Response Required"
  },
  "errors": {
    "not_found": "The requested resource could not be found.",
    "unauthorized": "You are not authorized to perform this action.",
    "server_error": "A server error occurred. Please try again later.",
    "network_error": "A network error occurred. Please check your connection.",
    "not_found_title": "We lost this page",
    "not_found_body": "The page you are looking for doesn't exist or has been moved.",
    "go_back": "Go back"
  },
  "pagination": {
    "previous": "Previous",
    "next": "Next",
    "page": "Page {{current}} of {{total}}",
    "showing": "Showing {{from}}–{{to}} of {{total}}"
  },
  "dates": {
    "today": "Today",
    "yesterday": "Yesterday",
    "just_now": "Just now",
    "ago": "{{time}} ago"
  }
}
